<template lang='pug' src='./accessibility.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Hero from 'components/hero/hero'
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'

export default {
  name: 'Accessibility',
  computed: {
    props () {
      return this.$store.state.pages['thank-you']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  data () {
    return {
      companyName: 'Lakenona Orthodontics', // Fill this in
      domain: "<a href='https://lakenonaorthodontics.com'>lakenonaorthodontics.com</a>", // Fill this in
      email: "<a href='mailto:info@sakowitzsmiles.com'>info@sakowitzsmiles.com</a>", // Fill this in
      phone: "<a href='tel:+14076271187'>407.627.1187</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    navScrolled () {
      this.$store.dispatch('VIEW_NAV', true)
    },
    notScrolled () {
      this.$store.dispatch('VIEW_NAV', false)
    },
    openModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', {})
    },
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  },
  components: {
    Loader,
    Hero,
    VueTrigger
  }
}
</script>



// WEBPACK FOOTER //
// accessibility.vue?36ef4dc9